import {ADVERTISING_CONSTS} from "../constants";

export const initialState = {
    advertisingList: [],
    advertisingById: null,
};

export default (state = initialState, action) => {
    switch (action.type) {
        case ADVERTISING_CONSTS.GET_ADVERTISING:
            return {
                ...state,
                advertisingList: action.payload || [],
            };
        case ADVERTISING_CONSTS.CREATE_ADVERTISING:
            return {
                ...state,
                advertisingList: [action.payload].concat(state.advertisingList)
            };
        case ADVERTISING_CONSTS.DELETE_ADVERTISING_BY_ID:
            return {
                ...state,
                advertisingList: state.advertisingList.filter(item => item.id !== action.payload)
            };
        case ADVERTISING_CONSTS.GET_ADVERTISING_BY_ID:
            return {
                ...state,
                advertisingById: action.payload
            };
        default:
            return state;
    }
}
